jQuery(document).ready(function( $ ){
	// START JQUERY
	logit = (typeof logit !== 'undefined')? logit : false;


	// Copy to page - all options:
	// #
	// var forms_validate_enable = true; // Enable or disable form validation
	// var forms_privacy_check_enable = true; // Enable or disable check all function
	// var forms_privacy_checking_enable =  true; // Disable send button until privacy checked - Enable or disable

	// var forms_validate_class = 'needs-validation';
	// var forms_validate_success = 'was-validated';
	// var forms_privacy_check_all_id =  'privacy-check-all'; // check all checkbox
	// var forms_privacy_checkbox_class =  'privacy-check'; // all other checkboxes
  // var forms_privacy_checking_btn_id =  'send-btn'; // Form send button ID
	// var forms_privacy_checking_trigger_id =  'privacy-consent'; // Privacy consent checkbox ID


	forms_validate_enable = (typeof forms_validate_enable !== 'undefined')? forms_validate_enable : true; // Enable or disable form validation
	forms_validate_class = (typeof forms_validate_class !== 'undefined')? forms_validate_class : 'needs-validation'; // Form class
	forms_validate_success = (typeof forms_validate_success !== 'undefined')? forms_validate_success : 'was-validated'; // Validated class

	forms_privacy_check_enable = (typeof forms_privacy_check_enable !== 'undefined')? forms_privacy_check_enable : true; // Enable or disable check all function
	forms_privacy_check_all_id = (typeof forms_privacy_check_all_id !== 'undefined')? forms_privacy_check_all_id : 'privacy-check-all'; // check all checkbox
	forms_privacy_checkbox_class = (typeof forms_privacy_checkbox_class !== 'undefined')? forms_privacy_checkbox_class : 'privacy-check'; // all other checkboxes

	forms_privacy_checking_enable = (typeof forms_privacy_checking_enable !== 'undefined')? forms_privacy_checking_enable : true; // Disable send button until privacy checked - Enable or disable
  forms_privacy_checking_btn_id = (typeof forms_privacy_checking_btn_id !== 'undefined')? forms_privacy_checking_btn_id : 'send-btn'; // Form send button ID
	forms_privacy_checking_trigger_id = (typeof forms_privacy_checking_trigger_id !== 'undefined')? forms_privacy_checking_trigger_id : 'privacy-consent'; // Privacy consent checkbox ID

  var forms_privacy_checking_btn_selector = '#' + forms_privacy_checking_btn_id;
  var forms_privacy_checking_trigger_selector = '#' + forms_privacy_checking_trigger_id;


	if(forms_privacy_checking_enable && forms_privacy_checking_trigger_id && forms_privacy_checking_btn_id) {

		function checkSendBtn() {
			if($(forms_privacy_checking_trigger_selector).prop('checked')) {
				$(forms_privacy_checking_btn_selector).prop('disabled', false);
				if(logit == 2) console.log('[PRIVACY CHECK] Enabled button - ref ');

			} else {
				$(forms_privacy_checking_btn_selector).prop('disabled', true);
				if(logit == 2) console.log('[PRIVACY CHECK] Disabled button - ref ');
			}
		}

		// DISABLE SEND NUTTON - CHECK PRIVACY FIRST
		if(forms_privacy_checking_enable) {
			if(logit) console.log('[PRIVACY CHECKING] Enabled: ' + forms_privacy_checking_trigger_selector + ', ' + forms_privacy_checking_btn_id);
			$(forms_privacy_checking_trigger_selector).change(function(){
				if(this.checked) {
					$(forms_privacy_checking_btn_selector).prop('disabled', false);
						if(logit == 2) console.log('[PRIVACY CHECKING] Enabled button');
				} else {
					$(forms_privacy_checking_btn_selector).prop('disabled', true);
						if(logit == 2) console.log('[PRIVACY CHECKING] Disabled button');
				}
			});

			checkSendBtn();
		}
	} else {
		forms_privacy_check_enable = false;
	  if(logit == 2) console.log('[PRIVACY CHECKING] Disabled');
	}


	// PRIVACY CHECKBOX HELPER
	if(forms_privacy_check_enable && forms_privacy_check_all_id && forms_privacy_checkbox_class) {
		if(logit) console.log('[PRIVACY CHECK ALL] Enabled: ' + forms_privacy_check_all_id + ', ' + forms_privacy_checkbox_class);
		$('.'+forms_privacy_check_all_id).click(function(){
			if(this.checked) {
				if(logit == 2) console.log('[PRIVACY CHECK ALL] Checked all');
				$('.'+forms_privacy_checkbox_class).prop('checked', true);
			} else {
				if(logit == 2) console.log('[PRIVACY CHECK ALL] Unchecked all');
				$('.'+forms_privacy_checkbox_class).prop('checked', false);
			}
			if(forms_privacy_checking_enable) checkSendBtn();
		});
	} else {
	  if(logit == 3) console.log('[PRIVACY CHECK] Disabled');
	}


	// FORM VALIDATION (BOOTSTRAP)
	if(forms_validate_enable && forms_validate_class && forms_validate_success) {
		(function() {
			'use strict';
				// Fetch all the forms we want to apply custom Bootstrap validation styles to
				var forms = document.getElementsByClassName(forms_validate_class);
				if(logit)  console.log('[FORMS VALIDATE] Activated!');
				// Loop over them and prevent submission
				var validation = Array.prototype.filter.call(forms, function(form) {
					form.addEventListener('submit', function(event) {


							event.preventDefault();
							if(logit == 2)  console.log('[FORMS VALIDATE] Started!');
							if (form.checkValidity() === false) {
								//event.preventDefault();
								event.stopPropagation();
								if(logit == 2)  console.log('[FORMS VALIDATE] Stopped! Invalid.');
							} else {
								if(logit == 2)  console.log('[FORMS VALIDATE] Valid!');
							}


						form.classList.add(forms_validate_success);
					}, false);
				});
		})();
	} else {
	  if(logit == 3) console.log('[FORMS VALIDATE] Disabled');
	}

// END JQUERY
});
